import React, { useEffect, useState } from "react";
import { MessageBox } from "./ChatInput";
import { toast } from "react-toastify";
import linkifyHtml from "linkify-html";
import DOMPurify from "dompurify";
import HostedVideoEmbed from "../Common/HostedVideoEmbed.jsx";
import {
  extractHostedVideoEmbeds,
  parseLinkifiedHtmlWithVideoEmbeds,
} from "../../Utils/parseLinkifiedHtmlWithVideoEmbeds";
import "../../css/assessment.css";

//goals and target chat send
const ChatSend = ({
  title1,
  title,
  username,
  time,
  botImage,
  continuousMsg,
  setIsThinkingLoading,
  isCurrentQuestion = false,
  isThinkingLoading = false,
  targets,
  withtargets = false,
  showTaskList = false,
  taskLists = null,
  isWinStack = false,
  achievedTasks = [],
  doneTasks = [],
  notDoneTasks = [],
  isScoreQuestion = false,
  setSliderValue = () => {},
  scoreValue = 0,
  setScoreValue = () => {},
  sliderRef = null,
  updateSliderBackground = () => {},
  handleScoreSubmit = () => {},
  isCompleted = false,
  editingMessage = null,
  handleSaveEdit = () => {},
  messageIndex,
  editingQuestionIndex,
  answeredValue = null,
  sliderValue = 0,
}) => {
  // Per-message slider state
  const isEditingThis =
    editingMessage?.isScore && editingQuestionIndex === messageIndex;
  const isAnswered =
    typeof answeredValue === "number" && !Number.isNaN(answeredValue);
  const showSlider = isScoreQuestion || isAnswered || isEditingThis;

  // If editing a score, only enable the slider for the question being edited
  let disabledSlider = (isAnswered && !isEditingThis) || isCompleted;
  if (editingMessage?.isScore && !isEditingThis) {
    disabledSlider = true;
  }

  // Decide what value to display on this slider
  const displayedValue = isEditingThis
    ? Number(scoreValue ?? sliderValue)
    : isAnswered
      ? Number(answeredValue)
      : Number(sliderValue);

  const handleRangeChange = (e) => {
    if (disabledSlider) return;
    const value = parseInt(e.target.value);
    setSliderValue(value);
    setScoreValue(value);
    updateSliderBackground(e.target);
  };

  const handleRangeSubmit = () => {
    if (disabledSlider) return;
    if (isEditingThis) {
      handleSaveEdit(editingMessage.messageId, String(displayedValue));
    } else {
      handleScoreSubmit(displayedValue);
    }
  };

  return (
    <>
      {!continuousMsg ? (
        <div
          className="mt-auto initial-journal-goal"
          id="journal-header"
          style={{ marginBottom: "0px" }}
        >
          <img
            className="chat-bot-img"
            src={botImage}
            alt="Journal Icon"
            style={{ opacity: 1 }}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              className="gap-1 gap-sm-2"
              style={{ display: "flex", alignItems: "center" }}
            >
              <span className="text-body-b2" style={{ color: "#e6ecf1" }}>
                {username}
              </span>
              <span
                className="text-caption-c2 align-self-end"
                style={{ color: "#d0d8df", marginLeft: "12px" }}
              >
                {time}
              </span>
            </div>

            {withtargets ? (
              <>
                {["yearly", "quarterly", "monthly", "weekly"].map((period) => {
                  const entries = targets[period];
                  // Capitalize the period for the title
                  const title =
                    period.charAt(0).toUpperCase() +
                    period.slice(1) +
                    " Tasks:";

                  return (
                    <div
                      key={period}
                      className="text-body-b2 goals-text-message-part mb-3 mb-sm-4"
                    >
                      <p
                        className="text-body-b1"
                        style={{ marginBottom: "8px" }}
                      >
                        {title}
                      </p>

                      {entries.map((entry) => (
                        <div
                          key={entry.id}
                          className="d-flex align-items-center "
                          style={{ gap: "12px" }}
                        >
                          <img
                            src={
                              entry.achieved
                                ? "/icons/smalltick.svg"
                                : "/icons/smallcross.svg"
                            }
                            alt={entry.achieved ? "Achieved" : "Not achieved"}
                          />
                          <p
                            className="text-body-b2"
                            style={{ marginBottom: "0px" }}
                            dangerouslySetInnerHTML={{ __html: entry.text }}
                          ></p>
                        </div>
                      ))}
                    </div>
                  );
                })}
                <div className="text-body-b2 goals-text-message-part">
                  {isThinkingLoading && isCurrentQuestion ? (
                    <ThinkingLoader />
                  ) : (
                    <>
                      <p
                        className="text-body-b1"
                        style={{ marginBottom: "3px" }}
                      >
                        {title1}
                      </p>
                      <p
                        className="text-body-b2"
                        style={{ marginBottom: "0px" }}
                        dangerouslySetInnerHTML={{ __html: title }}
                      ></p>
                    </>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="text-body-b2 goals-text-message-part">
                  {isThinkingLoading && isCurrentQuestion ? (
                    <ThinkingLoader />
                  ) : (
                    <>
                      {" "}
                      {isWinStack ? (
                        <p>This is your today's tasks status</p>
                      ) : (
                        <>
                          <p
                            className="text-body-b1"
                            style={{ marginBottom: "3px" }}
                          >
                            {title1}
                          </p>
                          <p
                            className="text-body-b2"
                            style={{ marginBottom: "0px" }}
                            dangerouslySetInnerHTML={{ __html: title }}
                          ></p>
                        </>
                      )}
                      {/* Prefer new decoupled taskLists when provided, else fall back to legacy winstack sections */}
                      {showTaskList && taskLists ? (
                        <>
                          <style>{`
                          .task-list-card { border-radius: 16px; margin-top: 12px; }
                          .task-list-title { color: #9db2c1; font-weight: 600; margin: 12px 0 8px; display: flex; align-items: center; gap: 8px; }
                          .task-item { display: flex; align-items: flex-start; gap: 8px; color: #e6ecf1; margin-bottom: 8px; }
                          .task-icon { width: 10px; height: 10px; flex: 0 0 12px; margin-top: 5px; }
                          .task-separator { height: 8px; }
                        `}</style>

                          {(() => {
                            // Flatten only non-empty lists and render
                            const entries = Object.entries(taskLists || {});
                            const nonEmpty = entries.filter(
                              ([, val]) =>
                                Array.isArray(val?.items) &&
                                val.items.length > 0,
                            );
                            if (nonEmpty.length === 0) return null;

                            return (
                              <div className="task-list-card">
                                {nonEmpty.map(([key, val], idx) => (
                                  <div
                                    key={key}
                                    style={{
                                      marginBottom:
                                        idx < nonEmpty.length - 1 ? 8 : 0,
                                    }}
                                  >
                                    <div className="task-list-title">
                                      <span>{`Task List ${/\d+/.exec(key)?.[0] || idx + 1}`}</span>
                                      <img
                                        className="task-icon"
                                        src={
                                          val.showSuccessTick
                                            ? "/icons/smalltick.svg"
                                            : "/icons/smallcross.svg"
                                        }
                                        alt={
                                          val.showSuccessTick
                                            ? "Success"
                                            : "Not done"
                                        }
                                      />
                                    </div>
                                    {val.items.map((text, i) => (
                                      <div
                                        key={`${key}-item-${i}`}
                                        className="task-item"
                                      >
                                        <span className="text-body-b3">
                                          {text}
                                        </span>
                                      </div>
                                    ))}
                                    {idx < nonEmpty.length - 1 && (
                                      <div className="task-separator" />
                                    )}
                                  </div>
                                ))}
                              </div>
                            );
                          })()}
                        </>
                      ) : isWinStack ? (
                        <>
                          <style>{`
                            .win-stack-card { border-radius: 16px; margin-top: 12px; }
                            .ws-section-title { color: #9db2c1; font-weight: 600; margin: 12px 0 8px; }
                            .ws-item { display: flex; align-items: flex-start; gap: 8px; color: #e6ecf1; margin-bottom: 8px; }
                            .ws-icon { width: 10px; height: 10px; flex: 0 0 10px; margin-top: 6px; margin-right:5px;}
                            .ws-separator { height: 8px; }
                            .ws-task-level { color: #9db2c1; font-weight: 600; margin-right: 4px; }
                          `}</style>

                          {(() => {
                            // Filter out Hit List tasks from notDoneTasks
                            const filteredNotDoneTasks = notDoneTasks.filter(
                              (task) => {
                                const levelWord =
                                  (task.level || "").trim().split(/\s+/)[0] ||
                                  "";
                                return levelWord.toLowerCase() !== "hit";
                              },
                            );

                            // Separate MIT and DO tasks from filtered not done tasks
                            const mitNotDoneTasks = filteredNotDoneTasks.filter(
                              (task) => {
                                const levelWord =
                                  (task.level || "").trim().split(/\s+/)[0] ||
                                  "";
                                return levelWord.toLowerCase() === "mit";
                              },
                            );

                            const doNotDoneTasks = filteredNotDoneTasks.filter(
                              (task) => {
                                const levelWord =
                                  (task.level || "").trim().split(/\s+/)[0] ||
                                  "";
                                return levelWord.toLowerCase() === "do";
                              },
                            );

                            const hasAnyTasks =
                              achievedTasks.length > 0 ||
                              mitNotDoneTasks.length > 0 ||
                              doneTasks.length > 0 ||
                              doNotDoneTasks.length > 0;

                            if (!hasAnyTasks) return null;

                            return (
                              <div className="win-stack-card">
                                {/* MIT List Tasks Achieved Today */}
                                {achievedTasks.length > 0 && (
                                  <>
                                    <div className="ws-section-title">
                                      MIT List Tasks Achieved Today
                                    </div>
                                    {achievedTasks.map((task) => (
                                      <div
                                        key={task.id ?? task.title}
                                        className="ws-item"
                                      >
                                        <img
                                          className="ws-icon"
                                          src="/icons/smalltick.svg"
                                          alt="Achieved"
                                        />
                                        {(() => {
                                          const levelWord =
                                            (task.level || "")
                                              .trim()
                                              .split(/\s+/)[0] || "";
                                          const formatted = levelWord
                                            ? levelWord
                                                .charAt(0)
                                                .toUpperCase() +
                                              levelWord.slice(1).toLowerCase()
                                            : "";
                                          const rawTitleHTML =
                                            task.title ?? String(task);
                                          const cleanTitleHTML = rawTitleHTML
                                            .replace(
                                              /^(<br\s*\/?>(\s|&nbsp;)*)+/i,
                                              "",
                                            )
                                            .replace(/^(&nbsp;|\s)+/, "");
                                          return (
                                            <>
                                              {formatted && (
                                                <span className="">
                                                  {formatted}:
                                                </span>
                                              )}
                                              <span
                                                className="text-body-b3"
                                                dangerouslySetInnerHTML={{
                                                  __html: cleanTitleHTML,
                                                }}
                                              />
                                            </>
                                          );
                                        })()}
                                      </div>
                                    ))}
                                    {(mitNotDoneTasks.length > 0 ||
                                      doneTasks.length > 0 ||
                                      doNotDoneTasks.length > 0) && (
                                      <div className="ws-separator" />
                                    )}
                                  </>
                                )}

                                {/* MIT List Tasks Not Achieved Today */}
                                {mitNotDoneTasks.length > 0 && (
                                  <>
                                    <div className="ws-section-title">
                                      MIT List Tasks Not Achieved Today
                                    </div>
                                    {mitNotDoneTasks.map((task) => {
                                      const rawTitleHTML =
                                        task.title ?? String(task);
                                      const cleanTitleHTML = rawTitleHTML
                                        .replace(
                                          /^(<br\s*\/?>(\s|&nbsp;)*)+/i,
                                          "",
                                        )
                                        .replace(/^(&nbsp;|\s)+/, "");
                                      return (
                                        <div
                                          key={task.id ?? task.title}
                                          className="ws-item"
                                        >
                                          <img
                                            className="ws-icon"
                                            src="/icons/smallcross.svg"
                                            alt="Not achieved"
                                          />
                                          <span className="">Mit:</span>
                                          <span
                                            className="text-body-b3"
                                            dangerouslySetInnerHTML={{
                                              __html: cleanTitleHTML,
                                            }}
                                          />
                                        </div>
                                      );
                                    })}
                                    {(doneTasks.length > 0 ||
                                      doNotDoneTasks.length > 0) && (
                                      <div className="ws-separator" />
                                    )}
                                  </>
                                )}

                                {/* Do List Tasks Done Today */}
                                {doneTasks.length > 0 && (
                                  <>
                                    <div className="ws-section-title">
                                      Do List Tasks Done Today
                                    </div>
                                    {doneTasks.map((task) => (
                                      <div
                                        key={task.id ?? task.title}
                                        className="ws-item"
                                      >
                                        <img
                                          className="ws-icon"
                                          src="/icons/smalltick.svg"
                                          alt="Done"
                                        />
                                        {(() => {
                                          const levelWord =
                                            (task.level || "")
                                              .trim()
                                              .split(/\s+/)[0] || "";
                                          const formatted = levelWord
                                            ? levelWord
                                                .charAt(0)
                                                .toUpperCase() +
                                              levelWord.slice(1).toLowerCase()
                                            : "";
                                          const rawTitleHTML =
                                            task.title ?? String(task);
                                          const cleanTitleHTML = rawTitleHTML
                                            .replace(
                                              /^(<br\s*\/?>(\s|&nbsp;)*)+/i,
                                              "",
                                            )
                                            .replace(/^(&nbsp;|\s)+/, "");
                                          return (
                                            <>
                                              {formatted && (
                                                <span className="">
                                                  {formatted}:
                                                </span>
                                              )}
                                              <span
                                                className="text-body-b3"
                                                dangerouslySetInnerHTML={{
                                                  __html: cleanTitleHTML,
                                                }}
                                              />
                                            </>
                                          );
                                        })()}
                                      </div>
                                    ))}
                                    {doNotDoneTasks.length > 0 && (
                                      <div className="ws-separator" />
                                    )}
                                  </>
                                )}

                                {/* Do List Tasks Not Done Today */}
                                {doNotDoneTasks.length > 0 && (
                                  <>
                                    <div className="ws-section-title">
                                      Do List Tasks Not Done Today
                                    </div>
                                    {doNotDoneTasks.map((task) => {
                                      const rawTitleHTML =
                                        task.title ?? String(task);
                                      const cleanTitleHTML = rawTitleHTML
                                        .replace(
                                          /^(<br\s*\/?>(\s|&nbsp;)*)+/i,
                                          "",
                                        )
                                        .replace(/^(&nbsp;|\s)+/, "");
                                      return (
                                        <div
                                          key={task.id ?? task.title}
                                          className="ws-item"
                                        >
                                          <img
                                            className="ws-icon"
                                            src="/icons/smallcross.svg"
                                            alt="Not done"
                                          />
                                          <span className="">Do:</span>
                                          <span
                                            className="text-body-b3"
                                            dangerouslySetInnerHTML={{
                                              __html: cleanTitleHTML,
                                            }}
                                          />
                                        </div>
                                      );
                                    })}
                                  </>
                                )}
                              </div>
                            );
                          })()}
                        </>
                      ) : null}
                      {showSlider && (
                        <div
                          className="mt-3 d-flex flex-col"
                          style={{ width: "100%" }}
                        >
                          {/* Scoped styles for base rail and thumb; gradient now set inline per instance */}
                          <style>{`
                          .score-range {
                            -webkit-appearance: none;
                            appearance: none;
                            width: 100%;
                            height: 6px;
                            border-radius: 6px;
                            outline: none;
                            background: rgba(255,255,255,0.12);
                          }
                          .score-range::-webkit-slider-thumb {
                            -webkit-appearance: none;
                            appearance: none;
                            width: 18px;
                            height: 18px;
                            border-radius: 50%;
                            background: #ffffff;
                            border: 2px solid #008cff;
                            cursor: pointer;
                            box-shadow: 0 0 0 2px rgba(0,0,0,0.15);
                          }
                          .score-range::-moz-range-thumb {
                            width: 18px;
                            height: 18px;
                            border-radius: 50%;
                            background: #ffffff;
                            border: 2px solid #008cff;
                            cursor: pointer;
                          }
                          .score-range:disabled {
                            cursor: not-allowed;
                            opacity: 0.9;
                          }
                          .score-range:disabled::-webkit-slider-thumb {
                            border-color: #8a94a0;
                            cursor: not-allowed;
                            box-shadow: none;
                          }
                          .score-range:disabled::-moz-range-thumb {
                            border-color: #8a94a0;
                            cursor: not-allowed;
                          }
                          .score-labels {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 8px;
                            color: #e6ecf1;
                            font-size: 12px;
                            user-select: none;
                            padding: 0 2px;
                          }
                        `}</style>

                          <div
                            className="d-flex flex-column mb-2 mt-4"
                            style={{
                              gap: "8px",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <input
                                type="range"
                                className="score-range"
                                min="0"
                                max="10"
                                step="1"
                                value={displayedValue}
                                onChange={handleRangeChange}
                                ref={
                                  isEditingThis ||
                                  (isCurrentQuestion && isScoreQuestion)
                                    ? sliderRef
                                    : null
                                }
                                disabled={disabledSlider}
                                style={{
                                  // Per-instance gradient: blue when active, grey when disabled
                                  background: `linear-gradient(to right, ${
                                    isAnswered || !disabledSlider
                                      ? "#008cff"
                                      : "#8a94a0"
                                  } 0%, ${
                                    disabledSlider
                                      ? "rgba(255,255,255,0.28)"
                                      : "#008cff"
                                  } ${(displayedValue / 10) * 100}%, rgba(255,255,255,0.12) ${(displayedValue / 10) * 100}%, rgba(255,255,255,0.12) 100%)`,
                                }}
                              />
                            </div>

                            <div
                              className="score-labels"
                              style={{ width: "100%" }}
                            >
                              {Array.from({ length: 11 }).map((_, i) => (
                                <span key={i}>{i}</span>
                              ))}
                            </div>

                            {/* Always render the button; disable and grey out for answered (inactive) */}
                            {/*  */}
                          </div>

                          <button
                            className="btn btn-link p-0"
                            onClick={handleRangeSubmit}
                            disabled={disabledSlider}
                            style={{
                              color:
                                isAnswered || !disabledSlider
                                  ? "#008cff"
                                  : "#8a94a0",
                              border: "none",
                              background: "none",
                              padding: "8px",
                              cursor: disabledSlider
                                ? "not-allowed"
                                : "pointer",
                              opacity: disabledSlider ? 0.7 : 1,
                              marginLeft: "10px",
                              marginTop: "-15px",
                            }}
                            title={
                              disabledSlider
                                ? `Already answered`
                                : editingMessage
                                  ? `Update score: ${displayedValue}`
                                  : `Send score: ${displayedValue}`
                            }
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                            </svg>
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {isWinStack && (
                  <>
                    <div className="text-body-b2 goals-text-message-part">
                      {isThinkingLoading && isCurrentQuestion ? (
                        <ThinkingLoader />
                      ) : (
                        <>
                          <p
                            className="text-body-b1"
                            style={{ marginBottom: "3px" }}
                          >
                            {title1}
                          </p>
                          <p
                            className="text-body-b2"
                            style={{ marginBottom: "0px" }}
                            dangerouslySetInnerHTML={{ __html: title }}
                          ></p>
                        </>
                      )}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <div
          className="mt-auto initial-journal-goal"
          id="journal-header"
          style={{ marginBottom: "0px" }}
        >
          <img
            className="chat-bot-img"
            src={botImage}
            alt="Journal Icon"
            style={{ opacity: 0 }}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              className="gap-1 gap-sm-2"
              style={{ display: "none", alignItems: "center" }}
            >
              <span className="text-body-b2" style={{ color: "#e6ecf1" }}>
                {username}
              </span>
              <span
                className="text-caption-c2 align-self-end"
                style={{ color: "#d0d8df", marginLeft: "12px" }}
              >
                {time}
              </span>
            </div>
            <div className="text-body-b2 goals-text-message-part">
              {isThinkingLoading && isCurrentQuestion ? (
                <ThinkingLoader />
              ) : (
                <>
                  <p className="text-body-b1" style={{ marginBottom: "3px" }}>
                    {title1}
                  </p>
                  <p className="text-body-b2 mb-0">{title}</p>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
//goals and target chat send

const ChatReceive = ({
  response,
  responder,
  time,
  userImage,
  messageId,
  answerId,
  questionType,
  isEditing,
  disableEdit,
  onLike = () => {},
  onEdit = () => {},
  onReply = () => {},
  onSaveEdit = () => {},
  onCancelEdit = () => {},
  onShowYesNoModal = () => {},
}) => {
  const [isLiked, setIsLiked] = useState(false);
  const [showActions, setShowActions] = useState(false);
  const [editedText, setEditedText] = useState(response);

  const handleLike = (event) => {
    event.stopPropagation();
    setIsLiked((prev) => !prev);
    onLike(messageId);
  };

  const linkConvert = (content) => {
    return linkifyHtml(DOMPurify.sanitize(content ?? ""), {
      target: "_blank",
      rel: "noopener noreferrer",
    });
  };

  const stripHtml = (html) => {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  // Decodes HTML entities (e.g. "&amp;#x27;") while preserving the HTML tag
  // structure so the rich text editor can rehydrate formatting (bold, lists,
  // line breaks, etc.) when editing a previously sent answer.
  const decodeEntitiesPreserveHtml = (text = "", maxIterations = 3) => {
    if (!text) return "";
    let decoded = text;
    let previous = text;
    let iterations = 0;
    do {
      previous = decoded;
      const doc = new DOMParser().parseFromString(decoded, "text/html");
      decoded = doc.body.innerHTML || "";
      iterations += 1;
    } while (decoded !== previous && iterations < maxIterations);
    return decoded;
  };

  const handleEdit = (event) => {
    event.stopPropagation();
    if (disableEdit) {
      onShowYesNoModal(answerId, response);
      return;
    }
    const decoded = decodeEntitiesPreserveHtml(response);
    setEditedText(decoded);
    onEdit(answerId, decoded);
  };

  const handleCancelEdit = (event) => {
    event?.stopPropagation?.();
    onCancelEdit();
  };

  const handleReply = (event) => {
    event.stopPropagation();
    onReply(messageId);
  };

  const handleSendClick = (event) => {
    event?.stopPropagation?.();
    if (!answerId) {
      console.error("No answer ID available for saving edit");
      return;
    }
    if (questionType === "yes_no") {
      return;
    }
    onSaveEdit(answerId, editedText);
  };

  const handleTextChange = (e) => {
    setEditedText(e.target.value);
  };
  return (
    <div
      id="journal-response2"
      className={`journal-message-for-bot ${isLiked ? "liked" : ""} ${
        isEditing ? "editing" : ""
      }`}
      style={{ display: "flex", cursor: "pointer" }}
      onClick={() => setShowActions((prev) => !prev)}
    >
      <div
        className="message-edit-box"
        style={{ display: "flex", flexDirection: "column", alignItems: "end" }}
      >
        <div className="goals-chat-header-small d-flex align-items-center gap-4 messager-head">
          <span className="text-caption-c2" style={{ color: "#d0d8df" }}>
            {time}
          </span>
          <span className="text-body-b2" style={{ color: "#e6ecf1" }}>
            {responder}
          </span>
        </div>

        {(() => {
          const linkedHtml = linkConvert(response);
          const {
            videoUrls: hostedVideoUrls,
            textHtml: cleanedTextHtml,
            hasText: hasCleanedText,
          } = extractHostedVideoEmbeds(linkedHtml);

          return (
            <>
              {hostedVideoUrls.map((u, i) => (
                <div
                  key={`gtab-hve-${i}`}
                  className="chat-hosted-video-embed-wrapper"
                >
                  <HostedVideoEmbed url={u} />
                </div>
              ))}
              {hasCleanedText && (
                <div className="my-text-chat mb-0 new-message-content message-content position-relative text-body-b2">
                  {isEditing
                    ? parseLinkifiedHtmlWithVideoEmbeds(cleanedTextHtml)
                    : parseLinkifiedHtmlWithVideoEmbeds(cleanedTextHtml)}
                </div>
              )}
            </>
          );
        })()}

        {isLiked && !isEditing && (
          <span className="like-emoji">
            <span>👍</span>
          </span>
        )}

        {showActions && !isEditing && (
          <div className="message-actions mt-2 d-flex gap-2">
            <img
              className="action-iocn"
              src="/icons/chat-edit.svg"
              onClick={handleEdit}
              alt="edit"
            />
          </div>
        )}
      </div>

      <div className="ms-md-3 ms-1">
        <img
          src={userImage}
          alt="User Profile"
          className="user-profile-chat-image"
        />
      </div>
    </div>
  );
};

// message component for like edit and reply
const MessageComponent = ({
  type,
  name,
  time,
  content,
  imgSrc,
  onLike,
  onReply,
  onEdit,
  messageId,
  /** Pass from parent with conversationId for per-user draft in the editor (localStorage) */
  userProfile,
  conversationId,
}) => {
  const [isLiked, setIsLiked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleLike = (event) => {
    event.stopPropagation();
    setIsLiked((prevLiked) => !prevLiked);
    onLike(messageId);
  };
  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSendClick = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    window.location.reload();
  };

  return (
    <div
      className={`message ${type} ${isLiked ? "liked" : ""} ${
        isEditing ? "editing" : ""
      }`}
      tabIndex="0"
    >
      <img src={imgSrc} className="profile-img" alt={name} />
      <div className="message-edit-box">
        <div className="d-flex align-items-center gap-4 messager-head">
          <span className="text-body-b2 message-name-text">{name}</span>
          <span className="message-time text-caption-c2">{time}</span>
        </div>
        {isEditing ? (
          <div
            className="message received liked editing"
            onClick={(e) => e.stopPropagation()}
          >
            <MessageBox
              isExpandedByDefault={true}
              onSendClick={(event) => handleSendClick(event)}
              userProfile={userProfile}
              draftScopeId={
                conversationId != null && messageId != null
                  ? `${conversationId}:${messageId}`
                  : undefined
              }
            />
          </div>
        ) : (
          <>
            <div className="message-content position-relative text-body-b2">
              {content}
              {isLiked && (
                <span className="like-emoji">
                  <span>👍</span>
                </span>
              )}
            </div>
          </>
        )}
      </div>
      {!isEditing && (
        <div className="message-actions ms-auto">
          <img
            className="action-iocn"
            src="/icons/like-icon.svg"
            onClick={handleLike}
            alt="like"
          />
          <img
            className="action-iocn"
            src="/icons/reply-icon.svg"
            onClick={onReply}
            alt="reply"
          />
          <img
            className="action-iocn"
            src="/icons/chat-edit.svg"
            onClick={handleEdit}
            alt="edit"
          />
        </div>
      )}
    </div>
  );
};

const ThinkingLoader = () => {
  return (
    <div
      className="thinking-loader"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        color: "#d0d8df",
        fontSize: "14px",
      }}
    >
      <div
        className="thinking-dots"
        style={{
          display: "flex",
          gap: "4px",
        }}
      >
        <span
          className="dot"
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#d0d8df",
            borderRadius: "50%",
            animation: "thinking 1.4s ease-in-out infinite both",
            animationDelay: "0s",
          }}
        ></span>
        <span
          className="dot"
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#d0d8df",
            borderRadius: "50%",
            animation: "thinking 1.4s ease-in-out infinite both",
            animationDelay: "0.16s",
          }}
        ></span>
        <span
          className="dot"
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#d0d8df",
            borderRadius: "50%",
            animation: "thinking 1.4s ease-in-out infinite both",
            animationDelay: "0.32s",
          }}
        ></span>
      </div>
      <style>{`
        @keyframes thinking {
          0%,
          80%,
          100% {
            opacity: 0.3;
            transform: scale(1);
          }
          40% {
            opacity: 1;
            transform: scale(1.2);
          }
        }
      `}</style>
    </div>
  );
};
export { ChatSend, ChatReceive, MessageComponent, ThinkingLoader };
